{
  "pt": {
    "dashboard": {
      "greetings": {
        "afternoon": "Boa tarde {first_name}",
        "evening": "Boa noite {first_name}",
        "morning": "Bom dia {first_name}",
        "night": "Boa noite {first_name}"
      },
      "milestones": {
        "caught_up_subtitle": "Não tem itens pendentes de momento.",
        "caught_up_title": "Está tudo em dia",
        "status_active": "Em curso",
        "status_completed": "Concluído",
        "status_planned": "Planeado",
        "todo_now_title": "O que fazer agora",
        "journey_title": "O seu percurso",
        "journey_select_unit_title": "Selecione uma unidade",
        "journey_select_unit_subtitle": "Escolha uma unidade acima para ver o seu percurso.",
        "journey_no_active_title": "Nenhum marco ativo",
        "journey_no_active_subtitle": "Esta unidade ainda não iniciou o seu percurso.",
        "progress_completed": "{completed} / {total} concluído(s)",
        "previous_label": "Marcos anteriores",
        "completed_count": "{count} concluído(s)",
        "upcoming_more": "Mais {count} marcos futuros",
        "open_action": "Abrir",
        "due_before": "Antes de {date}",
        "show_more_tasks": "Mostrar mais {count} tarefa | Mostrar mais {count} tarefas",
        "show_less": "Mostrar menos"
      },
      "titles": {
        "activityFeed": "Feed de actividades",
        "assignedTasks": "As minhas tarefas",
        "newsFeed": "Feed de notícias",
        "ongoingTickets": "Em curso",
        "openTickets": "Aberto",
        "progress": "Progresso",
        "tickets": "Conversas",
        "totalTickets": "Todas as conversas",
        "unreadTickets": "Não lido",
        "yourAssignedTickets": "Atribuídas a si"
      }
    }
  }
}
